//libs
import React, { memo, useCallback } from 'react';

//compoennts
import ImageV2 from 'shared/components/ImageV2';

//helpers
import { getActionURLWithPLPFilters, getTipTileURL } from 'shared/layouts/Listing/helpers';

//styles
import { Anchor } from './styles';

interface TiptileProps {
  item: Listing.IProduct;
  imageSrc: string;
  width: number;
  className?: string;
  openInTab?: boolean;
  onInteraction?: VoidFunction;
  alt: string;
}

const EMPTY_FUNC = () => {};
const IMAGE_ASPECT_RATIO = 0.5;
const Tiptile = ({
  item,
  openInTab = false,
  onInteraction = EMPTY_FUNC,
  imageSrc = '',
  width,
  className,
  alt = '',
}: TiptileProps) => {
  const target = openInTab ? '_blank' : '_self';

  const actionUrl = getTipTileURL(getActionURLWithPLPFilters(item, 'actionUrl'));

  const handleTiptileClick = useCallback(
    (e) => {
      e.preventDefault();
      onInteraction && onInteraction();

      let URL = actionUrl;
      if (openInTab) {
        window.open(URL);
        return;
      }
      window.location.href = URL;
    },
    [actionUrl, onInteraction, openInTab]
  );

  return (
    <Anchor href={actionUrl} target={target} onClick={handleTiptileClick} className={className}>
      <ImageV2
        width={width}
        src={imageSrc}
        lazy={false}
        alt={alt}
        aspectRatio={IMAGE_ASPECT_RATIO}
      />
    </Anchor>
  );
};

export default memo(Tiptile);
